import * as Yup from 'yup';

import { obtenerNombresRepetidos } from '@shared/helpers/flights/reserve';

import isValidDate from '@shared/helpers/isValidDate';

import { calculateAge } from '@shared/helpers/calculateAge';

const passengerSchema = salida =>
  Yup.object().shape({
    name: Yup.string()
      .required('El nombre es requerido')
      .test('unique-name', 'Nombre repetido', function () {
        const { options, from } = this;

        const passengers = from?.[1]?.value?.passengers || [];

        const arrEqualNames = obtenerNombresRepetidos(passengers);

        return !arrEqualNames.includes(options.index);
      }),
    lastname: Yup.string().required('El apellido es requerido'),
    typeDNI: Yup.string()
      .required('El tipo de documento es requerido')
      .oneOf(['DNI', 'PASAPORTE'], 'Tipo de documento inválido'),
    dni: Yup.string()
      .required('Dato requerido')
      .test('dni-validation', 'Formato inválido', function (value) {
        const { typeDNI } = this.parent;

        if (!value) return false;

        if (typeDNI === 'DNI') {
          return /^\d{7,8}$/.test(value);
        }

        return /^[a-zA-Z0-9]{5,20}$/.test(value);
      }),
    gender: Yup.string().required('El género es requerido'),
    cuitType: Yup.string().required('El CUIL/CUIT pagador es requerido'),
    cuitNumber: Yup.string()
      .required('El número es requerido')
      .matches(/^\d*$/, 'Solo números permitidos')
      .test('cuit-length', 'Debe tener entre 7 y 11 dígitos', function (value) {
        if (!value) return false;
        return value.length >= 7 && value.length <= 11;
      }),
    caracteristicPhone: Yup.string()
      .matches(/^\d*$/, 'Solo números permitidos')
      .required('Dato requerido'),
    phone: Yup.string()
      .matches(/^\d*$/, 'Solo números permitidos')
      .required('El teléfono es requerido'),
    codePhone: Yup.string().required('El código es requerido'),

    birth: Yup.string()
      .required('Debe elegir una fecha')
      .test('valid-date', 'Debe elegir una fecha válida', value =>
        isValidDate(value)
      )
      .test('valid-age', 'Edad incorrecta para el tipo de pasajero', function (
        value
      ) {
        const { passengerType } = this.parent;

        if (!value) return false;
        const age = calculateAge(value, salida);

        if (passengerType === 0) return age >= 12;
        if (passengerType === 1) return age >= 2 && age < 12;
        if (passengerType === 2) return age < 2;
        return false;
      }),
  });

export const noTravelerSchema = Yup.object().shape({
  name: Yup.string().required('El nombre es requerido'),
  lastname: Yup.string().required('El apellido es requerido'),
  email: Yup.string()
    .required('El email es requerido')
    .email('El formato del email es incorrecto'),
  caracteristicPhone: Yup.string()
    .required('La característica es requerida')
    .matches(/^[0-9+\-\s()]+$/, 'Formato inválido'),
  phone: Yup.string()
    .required('El teléfono es requerido')
    .matches(/^[0-9+\-\s()]+$/, 'Formato inválido'),
});

export const contactInfoValidationSchema = Yup.object().shape({
  email: Yup.string()
    .required('El email es requerido')
    .email('El formato del email es incorrecto'),
  repeatEmail: Yup.string()
    .required('El email es requerido')
    .oneOf([Yup.ref('email')], 'Los emails deben coincidir'),
});

export const reserveValidationSchema = salida => {
  return Yup.object({
    passengers: Yup.array()
      .of(passengerSchema(salida))
      .required('Debe ingresar pasajeros')
      .min(1, 'Debe ingresar al menos un pasajero'),
    noTraveler: noTravelerSchema,
    contactInfo: contactInfoValidationSchema,
    id_entity: Yup.string().required('Dato requerido'),
    acceptedTerms: Yup.boolean().oneOf([true], 'Debes aceptar los términos'),
  });
};
